import { REGION_FIELD_CONFIG } from '~/consts/generalSettings';
import { getStore } from '~/mobx/AppStore';

const setRegionData = () => {
    const { generalSettingsStore } = getStore();
    const {
        selectedRegionData,
        getSelectedRegionAttribute,
        setRegionName,
        setRegionDescription,
        setRegionExtraVoteLabel,
        setRegionExtraVoteQuantity,
        setRegionNoVoteDescription,
        setRegionSettingsData,
    } = generalSettingsStore;

    const region = selectedRegionData?.name || '';
    const { attributes = [] } = selectedRegionData;
    const attrDescription = getSelectedRegionAttribute(attributes, REGION_FIELD_CONFIG.regionDescription);
    const attrExtraVoteLabel = getSelectedRegionAttribute(attributes, REGION_FIELD_CONFIG.regionExtraVoteLabel);
    const attrExtraVoteQuantity = getSelectedRegionAttribute(attributes, REGION_FIELD_CONFIG.regionExtraVoteQuantity);
    const attrNoVoteDescription = getSelectedRegionAttribute(attributes, REGION_FIELD_CONFIG.regionNoVoteDescription);

    setRegionName(region);
    setRegionDescription(attrDescription?.value || '');
    setRegionExtraVoteLabel(attrExtraVoteLabel?.value || '');
    setRegionExtraVoteQuantity(attrExtraVoteQuantity?.value || '');
    setRegionNoVoteDescription(attrNoVoteDescription?.value || '');
    setRegionSettingsData([...attributes]);

    const isValidForm = region && Number(attrExtraVoteQuantity?.value) > 0 ? true : false;
    if (isValidForm) {
        generalSettingsStore.setRegionNameError(false);
        generalSettingsStore.setRegionExtraVoteQuantityError(false);
    }
};

export default setRegionData;
